function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "classnames", "ramda", "react", "react-jss", "@braindate/util/lib/react/hoc/withForwardRef", "../icon/SpinnerIcon", "./BaseButton.style"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("classnames"), require("ramda"), require("react"), require("react-jss"), require("@braindate/util/lib/react/hoc/withForwardRef"), require("../icon/SpinnerIcon"), require("./BaseButton.style"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classnames, global.ramda, global.react, global.reactJss, global.withForwardRef, global.SpinnerIcon, global.BaseButton);
    global.BaseButton = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classnames, _ramda, React, _reactJss, _withForwardRef, _SpinnerIcon, _BaseButton) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _classnames = _interopRequireDefault(_classnames);
  React = _interopRequireWildcard(React);
  _withForwardRef = _interopRequireDefault(_withForwardRef);
  _SpinnerIcon = _interopRequireDefault(_SpinnerIcon);
  _BaseButton = _interopRequireDefault(_BaseButton);
  var _excluded = ["className", "style", "isDisabled", "isSubmitting", "isFetching", "large", "fitText", "children", "withSuccess", "type", "onClick", "hasFocus", "autoFocus", "id", "forwardedRef", "withEvenSides", "aria-label", "aria-expanded", "aria-controls", "aria-pressed", "data-testid"];
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
  var useStyles = (0, _reactJss.createUseStyles)(_BaseButton.default);
  var BaseButton = function BaseButton(_ref) {
    var className = _ref.className,
      style = _ref.style,
      isDisabled = _ref.isDisabled,
      isSubmitting = _ref.isSubmitting,
      isFetching = _ref.isFetching,
      large = _ref.large,
      fitText = _ref.fitText,
      children = _ref.children,
      withSuccess = _ref.withSuccess,
      type = _ref.type,
      onClick = _ref.onClick,
      hasFocus = _ref.hasFocus,
      autoFocus = _ref.autoFocus,
      id = _ref.id,
      forwardedRef = _ref.forwardedRef,
      withEvenSides = _ref.withEvenSides,
      ariaLabel = _ref["aria-label"],
      ariaExpanded = _ref["aria-expanded"],
      ariaControls = _ref["aria-controls"],
      ariaPressed = _ref["aria-pressed"],
      dataTestid = _ref["data-testid"],
      props = _objectWithoutProperties(_ref, _excluded);
    /*
     |----------------------------------------------------------------------------
     | Refs
     |----------------------------------------------------------------------------
     */

    var rootRef = forwardedRef ? forwardedRef : /*#__PURE__*/React.createRef();

    /*
     |----------------------------------------------------------------------------
     | Effects
     |----------------------------------------------------------------------------
     */

    React.useEffect(function () {
      var rootElt = rootRef.current;

      // Get the button reference and focus on it. The setTimeout is needed
      // to make sure the focus action happen after the button is fully loaded.
      // FIXME: Dirty
      if (hasFocus && rootElt) {
        setTimeout(function () {
          return rootElt.focus();
        }, 0);
      }
    }, []);

    /*
     |----------------------------------------------------------------------------
     | Event Handlers
     |----------------------------------------------------------------------------
     */

    /*
     |----------------------------------------------------------------------------
     | Classes
     |----------------------------------------------------------------------------
     */

    var classes = useStyles({
      withEvenSides: withEvenSides
    });
    var rootClasses = (0, _classnames.default)(classes.root, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes["root-isSubmitting"], isSubmitting), classes["root-large"], large), classes["root-fitText"], fitText), classes["root-isFetching"], isFetching), classes["root-withSuccess"], !isDisabled && withSuccess));
    var spinnerClasses = (0, _classnames.default)(classes.spinner, _defineProperty({}, classes["spinner-isFetching"], isSubmitting || isFetching));

    /*
     |----------------------------------------------------------------------------
     | Elements
     |----------------------------------------------------------------------------
     */

    var spinnerElt = /*#__PURE__*/React.createElement("span", {
      className: spinnerClasses
    }, /*#__PURE__*/React.createElement(_SpinnerIcon.default, {
      small: true
    }));
    return /*#__PURE__*/React.createElement("button", _extends({}, props, {
      className: rootClasses,
      style: style,
      disabled: isDisabled || isFetching,
      type: type,
      onClick: onClick,
      ref: rootRef,
      id: id
      // eslint-disable-next-line jsx-a11y/no-autofocus
      ,
      autoFocus: autoFocus,
      "aria-label": ariaLabel,
      "aria-expanded": ariaExpanded,
      "aria-controls": ariaControls,
      "aria-pressed": ariaPressed,
      "data-testid": dataTestid
    }), spinnerElt, children);
  };
  var _default = _exports.default = (0, _ramda.compose)(React.memo, _withForwardRef.default)(BaseButton);
});